interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon = "ri-search-eye-line",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center border border-dashed border-background-300 rounded-lg bg-background-100/60">
      <span className="w-14 h-14 rounded-full bg-background-200 flex items-center justify-center">
        <i className={`${icon} text-2xl text-foreground-500`} />
      </span>
      <h3 className="mt-4 text-base font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 text-sm text-foreground-600 max-w-sm leading-relaxed">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}